import { Output } from "valibot";

import {
  BaseIntegrationsSchema,
  LocationBasedConsentInfo,
} from "components/SonicBot/schemas";
import { getLocalStorageValue } from "shared/functions";

import HelpScoutIntegrationHandler, { HelpScoutIntegration } from "./helpscout";

import { BaseIntegrationHandler } from ".";

export const generateIntegrationHandlers = (
  integrations: Output<typeof BaseIntegrationsSchema>,
) => {
  const integrationHandlers: BaseIntegrationHandler[] = [];
  for (const integration of integrations) {
    switch (integration.name) {
      case "Helpscout":
        // Create integration handlers by sorting through name
        integrationHandlers.push(
          new HelpScoutIntegrationHandler(integration as HelpScoutIntegration),
        );
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Unknown Integration: " + integration);
        break;
    }
  }
  return integrationHandlers;
};

export const isShowLocationBasedConsentForm = (
  botId: string,
  locationBasedConsentInfo?: Output<typeof LocationBasedConsentInfo>,
) => {
  if (!locationBasedConsentInfo) {
    return false;
  }
  const localStoarageConsentInfo = JSON.parse(
    getLocalStorageValue(`consentInfo__${botId}`) || "null",
  );
  const showLocationBasedConsentForm =
    locationBasedConsentInfo?.is_required &&
    (!localStoarageConsentInfo ||
      !localStoarageConsentInfo?.isConsentGiven ||
      localStoarageConsentInfo?.lastUpdatedAt !==
        locationBasedConsentInfo?.updated_at);

  return showLocationBasedConsentForm;
};
